<template>
  <div class="msg">
    <!-- <v-select id="team" v-model="team_id" :items="teams" :label="getI18n('team')" :disabled="params.team.disabled"></v-select> -->
    <v-select
      id="tmpl_team"
      v-model="tmpl_team_id"
      :items="tmpl_teams"
      :label="getI18n('params.position')"
      :disabled="params.tmpl_team.disabled"
    ></v-select>
    <v-select
      id="tmpl_team"
      v-model="categorySelected"
      :items="categories"
      item-value="id"
      item-text="name"
      :label="getI18n('params.category')"
      :disabled="params.tmpl_team.disabled"
    ></v-select>
    <v-select
      id="team"
      :no-data-text="getI18n('errors.write_3_characters')"
      v-model="team_id"
      :label="getI18n('team')"
      :items="teams"
      autocomplete
      :disabled="params.team.disabled"
    ></v-select>
  </div>
</template>

<script>
import store from "@/store";
import i18n from "@/i18n";
import { Api } from "@/core/api.js";
const api = new Api();

export default {
  props: { params: Object },
  components: {},
  data() {
    return {
      team_id: this.params.team.value,
      tmpl_team_id: this.params.tmpl_team.value,
      event_id: this.params.event_id,
      category_item: this.params.category_item,
      clubs: []
    };
  },
  computed: {
    tmpl_teams: function() {
      var tmplteams = this.params.is_groups ? ObjectToArray(
        store.getters["competition/groups/getTmplTeams"]()
      ) : ObjectToArray(
        store.getters["competition/getListTmplTeams"]()
      );
      var aTmplTeams = [];
      tmplteams.forEach(tt => {
        aTmplTeams.push({ text: tt.name, value: tt.id });
      });

      return aTmplTeams;
    },

    categories() {
      var categoriesData = store.getters["events/getCategoriesEventSelected"]();
      categoriesData.unshift({ id: -1, name: i18n.t("all") });
      return categoriesData;
    },

    categorySelected() {
      return {
        id: this.category_item.category_id,
        name: this.category_item.category
      };
    },

    teams: function() {
      var teams = store.getters["teams/getList"]();
      var aTeams = [];
      for (var i in teams) {
        var t = teams[i];
        if (
          t.event.id == this.event_id &&
          t.status == "6" &&
          t.category.id == this.category_item.category_id
        ) {
          aTeams.push({ text: t.name, value: t.id });
        }
      }

      aTeams.sort(function(t1, t2) {
        if (t1.name < t2.name) return 1;
        return -1;
      });

      aTeams.unshift({ text: "No assignar equip", value: -1 });

      return aTeams;
    }
  },
  methods: {
    getI18n(label) {
      return i18n.t(label);
    },

    formatEventName(name, edition) {
      return name + "'" + edition.substring(2);
    },

    formatParam(param) {
      switch (param.type) {
        case "string":
          return param.value;
        case "role":
          return param.value.name;
        case "email":
          return param.value;
        case "phone":
          return "<v-icon size='18px'>phone</v-icon>" + param.value;
      }
    }
  },
  created() {
    var self = this;
    store
      .dispatch("teams/loadList", {
        event: this.params.event_id,
        page_options: { num_items: -1, page: -1 },
        filters: {
          status: "6"
        }
      })
      .then(function(response) {});
  },
  watch: {
    team_id: {
      handler(v) {
        this.params.team.value = v;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar {
  width: 100%;
  height: 150px;
  text-align: center;

  img {
    height: 100%;
    width: auto;
  }
}

.item {
  text-align: center;
  margin: 10px auto;
  width: fit-content;

  &.strong .value {
    font-weight: bold;
    font-size: 22px;
  }

  &.role {
    border-radius: 15px;
    padding: 5px 15px;
    font-weight: lighter;
    margin: 0 auto;

    &.r5 {
      background-color: $bg-role-5;
      color: $co-role-5;
    }

    & .value {
      font-size: 18px;
      text-transform: uppercase;
    }
  }

  &.club {
    position: relative;
  }
}
</style>
